import React from 'react';
import { useNavigate } from 'react-router-dom';

import { getInspectModeData } from 'src/utils/contentful';
import { ResourceCard } from 'src/components/ResourceCard';
import { ContentfulRelatedContentResource } from 'src/graphql/queries/GetSmCourse';
import { ContentType } from 'src/types';
import { ResourceType } from 'src/constants';
import { getContentProduct } from 'src/utils/getContentProduct';
import { getUrlPrefix } from 'src/services/http/user';
import { getSlug } from 'src/utils/slug';

export interface RecommendedResourceProps {
  resource: ContentfulRelatedContentResource;
  sequence: number;
}

export const RecommendedResource: React.FC<RecommendedResourceProps> = ({ resource }) => {
  const navigate = useNavigate();
  const resourceSlug = getSlug(resource);

  if (resource?.__typename === ContentType.LEARNING_PATH) {
    return (
      <ResourceCard
        contentType={ResourceType.LearningPath}
        product={getContentProduct(resource.product)}
        inspectMode={getInspectModeData(resource, ['title'])}
        title={resource.title}
        tags={[{ label: 'learning path' }]}
        link={`${getUrlPrefix()}/path/${resourceSlug}`}
        target="_self"
        onClick={() => navigate(`/path/${resourceSlug}`)}
      />
    );
  }

  if (resource?.__typename === ContentType.COURSE) {
    return (
      <ResourceCard
        contentType={ResourceType.SmCourse}
        product={getContentProduct(resource.product)}
        inspectMode={getInspectModeData(resource, ['title'])}
        title={resource.title}
        tags={[{ label: 'course' }]}
        target="_self"
        link={`${getUrlPrefix()}/course/${resourceSlug}`}
        onClick={() => navigate(`/course/${resourceSlug}`)}
      />
    );
  }

  if (resource?.__typename === ContentType.LESSON) {
    const courseSlug = getSlug(resource.linkedFrom?.smCourseCollection.items[0]);

    return (
      <ResourceCard
        contentType={ResourceType.SmLesson}
        product={getContentProduct(resource.products)}
        inspectMode={getInspectModeData(resource, ['title'])}
        title={resource.title}
        tags={[{ label: 'lesson' }]}
        target="_self"
        link={`${getUrlPrefix()}/course/${courseSlug}/lesson/${resourceSlug}`}
        onClick={() => navigate(`/course/${courseSlug}/lesson/${resourceSlug}`)}
      />
    );
  }

  return null;
};
